class FAQ extends HTMLElement {
  constructor() {
    super();

    const itemFaq = document.querySelectorAll('.js-toggleQA');

    if (itemFaq.length > 0) {
      itemFaq.forEach(element => {
        element.addEventListener('click', function() {
          this.closest('.item').classList.toggle("active");
        });
      });
    }
  }
}

customElements.define('section-faq', FAQ);
